import { render, staticRenderFns } from "./allzhaobiaoxq.vue?vue&type=template&id=4cfb4b90&scoped=true&"
import script from "./allzhaobiaoxq.vue?vue&type=script&lang=js&"
export * from "./allzhaobiaoxq.vue?vue&type=script&lang=js&"
import style0 from "./allzhaobiaoxq.vue?vue&type=style&index=0&id=4cfb4b90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfb4b90",
  null
  
)

export default component.exports